module.exports = __webpack_public_path__ + "static/media/dice-three.7935f493.svg";